import adminApi from "../../api";

class AdminCategoryService {
  async getAllCategories() {
    const response = await adminApi.get("/categories");
    return response.data;
  }

  async createCategory({ name, imageFile, sortOrder }) {
    const formData = new FormData();
    formData.append("name", name);
    if (sortOrder !== undefined && sortOrder !== null) {
      formData.append("sort_order", String(sortOrder));
    }
    if (imageFile) {
      formData.append("image", imageFile);
    }
    const response = await adminApi.post("/categories", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  }

  async updateCategory(id, { name, imageFile, sortOrder }) {
    const formData = new FormData();
    if (name !== undefined) {
      formData.append("name", name);
    }
    if (sortOrder !== undefined && sortOrder !== null) {
      formData.append("sort_order", String(sortOrder));
    }
    if (imageFile) {
      formData.append("image", imageFile);
    }
    const response = await adminApi.put(`/categories/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  }

  async deleteCategory(id) {
    const response = await adminApi.delete(`/categories/${id}`);
    return response.data;
  }

  async setCategoryStopList(id, isStopList) {
    const response = await adminApi.patch(`/categories/${id}/stop-list`, {
      is_stop_list: isStopList,
    });
    return response.data;
  }
}

export default new AdminCategoryService();
